import React, { useState } from 'react';
import api from '../../api'; 
import { toast } from 'react-toastify';

const Contact = () => {
  const [formData, setFormData] = useState({
    customerName: '',
    customerNo: '',
    messageReason: 'General Inquiry',
    customerMessage: ''
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const userId = localStorage.getItem("userId") || "0"; 

    try {
      await api.post('/customerMessage/add', {
        userID: userId,
        ...formData
      });
      toast.success("Message sent successfully!");
      setFormData({ customerName: '', customerNo: '', messageReason: 'General Inquiry', customerMessage: '' });
    } catch (error) {
      console.error("Error sending message", error);
      toast.error("Failed to send message. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ backgroundColor: "#f8f9fa", minHeight: "100vh", paddingBottom: "3rem" }}>
      
      {/* --- 1. HEADER --- */}
      <div className="bg-white py-5 shadow-sm mb-5">
        <div className="container text-center">
          <h1 className="fw-bold text-dark" style={{ fontSize: '3rem' }}>Contact Us</h1>
          <p className="text-muted mx-auto" style={{ maxWidth: '600px', fontSize: '1.1rem' }}>
            We are here to help. Send us a message or visit our premises.
          </p>
        </div>
      </div>

      <div className="container">
        
        {/* --- 2. CONTACT FORM (Centered) --- */}
        <div className="row justify-content-center mb-5">
            <div className="col-lg-8">
                <div className="card shadow border-0 rounded-4">
                    <div className="card-body p-5">
                        <div className="text-center mb-4">
                            <h3 className="fw-bold">Send us a Message</h3>
                            <p className="text-muted small">We typically reply within 24 hours.</p>
                        </div>

                        <form onSubmit={handleSubmit}>
                            <div className="row g-3">
                                <div className="col-md-6">
                                    <label className="form-label small fw-bold text-secondary">Your Name</label>
                                    <input type="text" className="form-control bg-light border-0 py-3" name="customerName" value={formData.customerName} onChange={handleChange} placeholder="Name" required />
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label small fw-bold text-secondary">Phone Number</label>
                                    <input type="text" className="form-control bg-light border-0 py-3" name="customerNo" value={formData.customerNo} onChange={handleChange} placeholder="+91 xxxxx xxxxx" required />
                                </div>
                                <div className="col-12">
                                    <label className="form-label small fw-bold text-secondary">Reason</label>
                                    <select className="form-select bg-light border-0 py-3" name="messageReason" value={formData.messageReason} onChange={handleChange}>
                                        <option>General Inquiry</option>
                                        <option>Order Support</option>
                                        <option>Returns/Refund</option>
                                        <option>Feedback</option>
                                        <option>Other</option>
                                    </select>
                                </div>
                                <div className="col-12">
                                    <label className="form-label small fw-bold text-secondary">Message</label>
                                    <textarea className="form-control bg-light border-0 py-3" rows="5" name="customerMessage" value={formData.customerMessage} onChange={handleChange} placeholder="How can we help you?" required></textarea>
                                </div>
                                <div className="col-12 text-center mt-4">
                                    <button 
                                        type="submit" 
                                        className="btn btn-warning px-5 py-3 rounded-pill fw-bold shadow-sm"
                                        disabled={loading}
                                        style={{ minWidth: '200px', fontSize: '1.1rem' }}
                                    >
                                        {loading ? 'Sending...' : 'Send Message'}
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>

        {/* --- 3. CONTACT INFO (3 Columns) --- */}
        <div className="row g-4 mb-5">
            {/* Phone */}
            <div className="col-md-4">
                <div className="card h-100 border-0 shadow-sm rounded-4 text-center p-4">
                    <div className="mx-auto mb-3 d-flex align-items-center justify-content-center" style={{ width: 60, height: 60, borderRadius: '50%', backgroundColor: '#FFF4CC', color: '#FFA900' }}>
                        {/* ➤ ADDED SVG FOR PHONE */}
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                          <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                        </svg>
                    </div>
                    <h5 className="fw-bold">Phone</h5>
                    <p className="text-muted mb-1">Mon-Sat 9am to 6pm</p>
                    <p className="fw-bold fs-5 text-dark">+91 62830 13500</p>
                </div>
            </div>

            {/* Email */}
            <div className="col-md-4">
                <div className="card h-100 border-0 shadow-sm rounded-4 text-center p-4">
                    <div className="mx-auto mb-3 d-flex align-items-center justify-content-center" style={{ width: 60, height: 60, borderRadius: '50%', backgroundColor: '#E0F7FA', color: '#00BCD4' }}>
                        {/* ➤ ADDED SVG FOR EMAIL */}
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                          <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                          <polyline points="22,6 12,13 2,6"></polyline>
                        </svg>
                    </div>
                    <h5 className="fw-bold">Email</h5>
                    <p className="text-muted mb-1">Online Support</p>
                    <a href="mailto:info@divinedepot.in" className="fw-bold fs-5 text-dark text-decoration-none">info@divinedepot.in</a>
                </div>
            </div>

            {/* Address */}
            <div className="col-md-4">
                <div className="card h-100 border-0 shadow-sm rounded-4 text-center p-4">
                    <div className="mx-auto mb-3 d-flex align-items-center justify-content-center" style={{ width: 60, height: 60, borderRadius: '50%', backgroundColor: '#E8F5E9', color: '#4CAF50' }}>
                        {/* ➤ ADDED SVG FOR ADDRESS */}
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                          <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                          <circle cx="12" cy="10" r="3"></circle>
                        </svg>
                    </div>
                    <h5 className="fw-bold">Address</h5>
                    <p className="text-muted mb-0">Radha Nikunj Bihari Industries</p>
                    <p className="text-dark fw-bold mb-0">145, SG Enclave, Majitha Road</p>
                    <p className="text-dark">Amritsar, Punjab</p>
                </div>
            </div>
        </div>

        {/* --- 4. MAP SECTION --- */}
        <div className="row">
            <div className="col-12">
                <h3 className="fw-bold mb-4 text-center">Find Us on Maps</h3>
                <div className="shadow rounded-4 overflow-hidden" style={{ height: '400px' }}>
                    <iframe 
                        title="Divine Depot Location"
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3396.6575317765173!2d74.876!3d31.649!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzHCsDM4JzU2LjQiTiA3NMKwNTInMzMuNiJF!5e0!3m2!1sen!2sin!4v1600000000000!5m2!1sen!2sin" 
                        width="100%" 
                        height="100%" 
                        style={{ border: 0 }} 
                        allowFullScreen="" 
                        loading="lazy">
                    </iframe>
                </div>
            </div>
        </div>

      </div>
    </div>
  );
};

export default Contact;